import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CountdownTimer } from 'components/CountdownTimer/CountdownTimer';

export class OfferExpiryCountdown extends PureComponent {
  render() {
    const { countdownTo } = this.props;

    return (
      <p className="text--bold">
        <FormattedMessage id="inviteafriend.offer-expires-in" defaultMessage="Offer expires in" />
        &nbsp;
        <CountdownTimer countdownTo={countdownTo} />
      </p>
    );
  }
}

OfferExpiryCountdown.propTypes = {
  countdownTo: PropTypes.number.isRequired,
};
